module.exports = __webpack_public_path__ + "media/images/slide_01-ebcd4dd981528a7b332603dc0d82784e.jpg";